import { createSlice } from '@reduxjs/toolkit'

export const documentConfig = createSlice({
    name: 'documentConfig',
    initialState: {
        document: {},
        general: {},
        schema: {},
        output: [],
        effectivity: [],
    },
    reducers: {
        setConfigDocument: (state, action) => {
            state.document = action.payload;
        },
        setConfigGeneral: (state, action) => {
            state.general = action.payload;
        },
        setConfigSchema: (state, action) => {
            state.schema = action.payload;
        },
        setConfigOutput: (state, action) => {
            state.output = action.payload;
        },
        setConfigEffectivity: (state,action) => {
            state.effectivity = action.payload;
        }
    },
});

export const { setConfigDocument, setConfigGeneral, setConfigSchema, setConfigEffectivity, setConfigOutput } = documentConfig.actions;

